import * as B from '../block'
import {Admin, defaultConfig} from './admin'

export const StaticPageBlock = B.blockWithInfo(
  {
    name: 'static-page-content',
    displayName: 'StaticPageBlock',
    title: 'Static Page Content',
    defaultConfig,
    Admin,
  },
  ({config}) => {
    return (
      <B.Section>
        <B.StaticContent {...config} />
      </B.Section>
    )
  },
)
